
import { defineComponent } from "vue";
import slideInfo from "../slide-info/slide-info.vue";

export default defineComponent({
  components: { slideInfo },

  data() {
    return {
      teamList: [
        { title: '星级月嫂', desc: '提供居家护理服务，包括宝宝护理、妈妈护理、月子餐制作等', img: 'https://mm2015.mamalaile.com.cn/ac1c1a7d9418c22100ce1a0f1fcf0a16.png' },
        { title: '服务管家', desc: '妈妈来了会给每一位用户匹配一个专属的服务管家全程跟踪您的服务', img: 'https://mm2015.mamalaile.com.cn/2541964a4c086da501e16b1c2d4329ee.png' },
        { title: '月子顾问', desc: '跟进您整个孕期，月子期身体异常、生产准备、产后康复等相关问题，减少您的孕期焦虑', img: 'https://mm2015.mamalaile.com.cn/9d7750059ad26fc7533c38479a7c9d7a.png' },
        { title: '护理老师', desc: '全程跟进宝妈、宝宝的医护问题，解决宝妈担心的母乳喂养、产后康复等问题', img: 'https://mm2015.mamalaile.com.cn/01e944ff5d16a4e6ca202a50d8077679.png' },
      ],
      decorateList: [
        { position: 'bottom-left', url: require('/src/assets/images/home_pic5_bg@2x.png'), width: 28.07 },
      ]
    };
  }
});
